import { FC, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { withAuthenticationRequired } from '@auth0/auth0-react';

import { TokenProviderContext } from '@src/core/auth/components/token-provider.component';
import { Can } from '@src/core/rbac/rbac-protection.provider';
import { RoutePathsEnum } from '@src/core/routing/route-paths.enum';
import { RestrictionWrapperComponentPropsInterface } from '../types/restriction-wrapper.interface';

const RestrictionFallbackComponent = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(RoutePathsEnum.Error403);
  });
  return <></>;
};

const RestrictionWrapperComponent: FC<RestrictionWrapperComponentPropsInterface> = (props) => {
  const { children: Component, resource, permission } = props;

  const { isContextSettled } = useContext(TokenProviderContext);

  return (
    <Can passThrough I={permission} a={resource}>
      {(allowed) => {
        if (!isContextSettled) {
          return <></>;
        }
        if (!allowed) {
          return <RestrictionFallbackComponent />;
        }
        return Component;
      }}
    </Can>
  );
};

export const ProtectionWrapperComponent = withAuthenticationRequired(RestrictionWrapperComponent);
